import { Injectable } from '@angular/core';
import { ApiService } from "../api.service";

const PATH = "provider";

@Injectable({
  providedIn: 'root'
})
export class EmailProviderHandlerService {

  constructor(private APIService: ApiService) {}

  getTemplates(provider: string, integrationID: number){
    return this.APIService.get(`${PATH}/${provider}/${integrationID}/templates`)
  }

}
